import * as momentTz from 'moment-timezone'

export const setLabelFullPublicationDate = (date, userTimeZone) =>
  !!date &&
  `${momentTz
    .tz(date, userTimeZone)
    .format('LL - hh:mm A')
    .replace('12:00 AM', '00:00 AM')} ${userTimeZone}`
// w
